import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { AuthFormComponent, AuthMode } from '../../shared/auth-form.component';
import { User } from '../../shared/UserInterface';

@Component({
    selector: 'app-auth-modal',
    standalone: true,
    imports: [AuthFormComponent],
    template: `
        <div class="auth-modal-overlay" (click)="close.emit()">
            <div class="auth-modal" (click)="$event.stopPropagation()">
                <app-auth-form 
                    [isModal]="true"
                    [initialMode]="initialMode"
                    (authSuccess)="onAuthSuccess($event)"
                    (formCancel)="close.emit()">
                </app-auth-form>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [`
        .auth-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
        }
        
        .auth-modal {
            background: white;
            border-radius: 8px;
            padding: 24px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
            max-width: 500px;
            width: 90%;
            max-height: 90vh;
            overflow-y: auto;
        }
    `]
})
export class AuthModalComponent {
    @Input() initialMode: AuthMode = AuthMode.LOGIN;
    @Output() authSuccess = new EventEmitter<User>();
    @Output() close = new EventEmitter<void>();
    
    onAuthSuccess(user: User): void {
        this.authSuccess.emit(user);
    }
}